import { Theme } from '@mui/material'

import makeStyles from '@mui/styles/makeStyles'

interface LinkStylesProps {
  active: boolean
}
const useStyles = makeStyles<Theme, LinkStylesProps>(theme => ({
  root: {
    padding: '1.2rem 1.8rem',
    fontSize: theme.size.sm,
    backgroundColor: ({ active }) => (active ? '#F6F7F8' : 'white'),
    transition: 'background-color 0.75s',
    cursor: 'pointer',
    userSelect: 'none',

    '&:hover': {
      backgroundColor: '#F6F7F8'
    }
  }
}))

export default useStyles
